import { render } from "./SurveyTopBottomSummary.vue?vue&type=template&id=0f557922"
import script from "./SurveyTopBottomSummary.vue?vue&type=script&lang=js"
export * from "./SurveyTopBottomSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__